import React from 'react';
import { Box, useMediaQuery, styled } from '@mui/material';

// Styled components using MUI v5 `styled`
const HeaderContainer = styled('div')({
  position: 'relative',
});

const HeaderLine = styled('div')({
  width: '100%',
  height: '2px',
  background: '#0F75BC',
  position: 'absolute',
  top: '6px',
});

const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: theme.spacing(0, 0, 3, 0),
  padding: 0,
}));

const Circle = styled('i')({
  width: '15px',
  height: '15px',
  border: '5px solid #fff',
  borderRadius: '50%',
  margin: '0 auto',
  display: 'block',
  backgroundColor: '#DFDFDF',
});

const Separator = styled('div')({
  flex: 1,
  marginTop: '10px',
  '& > i': {
    display: 'block',
    background: '#0F75BC',
    width: '100%',
    height: '2px',
  },
  '&:last-of-type': {
    display: 'none',
  },
});

const HeaderStep = styled('div')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: 12,
  color: '#808080',
  cursor: 'pointer',
  '& > span': {
    display: 'block',
  },
  '&.disabled': {
    cursor: 'not-allowed',
  },
  '&.active': {
    fontSize: 14,
    color: '#000',
    marginTop: '-3px',
    '& > i': {
      width: '20px',
      height: '20px',
      backgroundColor: '#F9B756',
    },
    '& > span': {
      marginTop: 0,
      fontWeight: 500,
    },
  },
}));

const Stepper = ({ activeStep, onStepChange, steps }) => {
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('md'));

  return (
    <HeaderContainer>
      <Header>
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <HeaderStep
              onClick={activeStep > index ? () => onStepChange(index) : undefined}
              className={`${activeStep === index ? 'active' : ''}${
                activeStep < index ? ' disabled' : ''
              }`}
            >
              <Circle />
              {isDesktop && <span>{step}</span>}
            </HeaderStep>
            {index < steps.length - 1 && (
              <Separator>
                <i></i>
              </Separator>
            )}
          </React.Fragment>
        ))}
      </Header>
    </HeaderContainer>
  );
};

export default Stepper;